<template>
  <v-container class="fill-height d-flex justify-center align-center">
    <form @submit.prevent="login">
      <v-card :loading="loading" class="pa-6" width="400">
        <v-card-title class="text-h6">Iniciar sesión</v-card-title>
        <v-card-text>
          <v-text-field v-model="username" label="Usuario" />
          <v-text-field 
            v-model="password" 
            label="Contraseña" 
            autocomplete="off"
            :type="showPassword ? 'text' : 'password'"
            :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append-inner="showPassword = !showPassword"
        />
        </v-card-text>
        <v-card-actions>
          <v-btn  block color="primary" type="submit">Entrar</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const router = useRouter()
const username = ref('')
const password = ref('')
const showPassword = ref(false)
const store = useStore()

const responseAuth = computed(() => store.state.Auth.responseAuth)

const loading = ref(false)

const login = async () => {
  loading.value = true;
  const formData = new FormData()
  formData.append('username',username.value ?? '')
  formData.append('password', password.value)
  await store.dispatch('Auth/login', formData)

  if (responseAuth.value?.success) {
    localStorage.setItem('token', responseAuth.value.token)
    router.push('/dashboard')
  }
  loading.value = false;
}
</script>
